import * as React from 'react';

import _t from 'i18n!nls/xdp';

export const getGoogleRefreshAiBadgeContent = (s12nSlug?: string) => {
  if (s12nSlug === 'google-data-analytics') {
    return (
      <ul>
        <li>{_t('Boost your data analytics skills with AI')}</li>
        <li>{_t('Clean and prepare data with help from AI')}</li>
        <li>{_t('Organize data and build formulas using AI')}</li>
        <li>{_t('Use AI to help you ask more effective questions')}</li>
        <li>{_t('Create engaging data visualizations with AI')}</li>
        <li>{_t('Improve your R code with help from AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-digital-marketing-ecommerce') {
    return (
      <ul>
        <li>{_t('Boost your digital marketing skills with AI')}</li>
        <li>{_t('Use AI to help you understand your audience')}</li>
        <li>{_t('Kickstart marketing strategy ideas with AI')}</li>
        <li>{_t('Use AI to compare two campaign proposals')}</li>
        <li>{_t('Improve your email marketing using AI')}</li>
        <li>{_t('Brainstorm website copy ideas with AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-it-support') {
    return (
      <ul>
        <li>{_t('Boost your IT support skills with AI')}</li>
        <li>{_t('Leverage AI for faster troubleshooting')}</li>
        <li>{_t('Communicate technical concepts with AI')}</li>
        <li>{_t('Automate routine IT tasks with AI')}</li>
        <li>{_t('Simplify IT documentation using AI')}</li>
        <li>{_t('Use AI to identify IT security risks')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-project-management') {
    return (
      <ul>
        <li>{_t('Boost your project management skills with AI')}</li>
        <li>{_t('Use AI to create a project charter')}</li>
        <li>{_t('Identify potential project risks with gen AI')}</li>
        <li>{_t('Use AI to improve project communications')}</li>
        <li>{_t('Execute meetings more efficiently with AI')}</li>
        <li>{_t('Plan Sprint retrospectives using AI')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-ux-design') {
    return (
      <ul>
        <li>{_t('Boost your UX design skills with AI')}</li>
        <li>{_t('Generate personas with help from AI')}</li>
        <li>{_t('Use AI to help with design iteration')}</li>
        <li>{_t('Improve stakeholder communication with AI')}</li>
        <li>{_t('Simplify complex frameworks using AI')}</li>
        <li>{_t('Use AI to help write your portfolio copy')}</li>
      </ul>
    );
  }
  if (s12nSlug === 'google-cybersecurity') {
    return (
      <ul>
        <li>{_t('Boost your cybersecurity skills with AI')}</li>
        <li>{_t('Decode complex security frameworks with AI')}</li>
        <li>{_t('Use AI to help identify bugs')}</li>
        <li>{_t('Refine code with help from AI')}</li>
        <li>{_t('Understand system vulnerabilities with AI')}</li>
        <li>{_t('Prioritize alerts with AI')}</li>
      </ul>
    );
  }

  return null;
};

export default getGoogleRefreshAiBadgeContent;
